var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',[_vm._v(" 更新履歴 ")]),_vm._l((_vm.logs),function(log,idx){return [(idx !== 0)?_c('v-divider',{key:`div-${log.id}`}):_vm._e(),_c('LogListItem',{key:log.id,attrs:{"log":log}})]}),_c('InfiniteLoading',{attrs:{"identifier":_vm.reservationId},on:{"infinite":_vm.onInfinite}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }